import React, { createContext, useContext, useState, useCallback, useEffect } from 'react'
import { v4 as uuidv4 } from 'uuid'
import { cn } from '../../../utils/classnames'
import {
    CheckCircle,
    AlertCircle,
    Info,
    AlertTriangle
  } from 'lucide-react'  

const ToastContext = createContext()

export const useToast = () => useContext(ToastContext)

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([])

  const addToast = useCallback(({ type = 'info', message, duration = 4000 }) => {
    const id = uuidv4()
    const newToast = { id, type, message, visible: false }

    setToasts(prev => [...prev, newToast])

    // Show animation
    setTimeout(() => {
      setToasts(prev =>
        prev.map(t => (t.id === id ? { ...t, visible: true } : t))
      )
    }, 100)

    // Hide animation
    setTimeout(() => {
      setToasts(prev =>
        prev.map(t => (t.id === id ? { ...t, visible: false } : t))
      )
    }, duration - 500)

    // Remove from DOM
    setTimeout(() => {
      setToasts(prev => prev.filter(t => t.id !== id))
    }, duration)
  }, [])

  return (
    <ToastContext.Provider value={{ addToast }}>
      {children}
      <div className="fixed bottom-4 right-4 space-y-2 z-50">
        {toasts.map(({ id, type, message, visible }) => (
          <div
            key={id}
            className={cn(
                'px-10 py-4 rounded-lg text-lg font-semibold flex items-center gap-2 border transform transition-all duration-500 ease-in-out',
                visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4',
                type === 'success' && 'bg-tealExtraLight2 text-tealMedium border-tealMedium',
                type === 'error' && 'bg-redExtraLight text-redBase border-redBase',
                type === 'warning' && 'bg-yellowUltraLight text-yellowDark border-yellowDark',
                type === 'info' && 'bg-blueExtraLight2 text-bluePrimary border-bluePrimary'
              )}              
          >
            <span>
                {type === 'success' && <CheckCircle size={24} />}
                {type === 'error' && <AlertCircle size={24} />}
                {type === 'warning' && <AlertTriangle size={24} />}
                {type === 'info' && <Info size={24} />}
            </span>
            <span>{message}</span>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  )
}
